package com.exura.features.userprofile.domain.model

import com.exura.features.firebase.domain.model.SerializableDomainModel
import com.exura.features.newauth.domain.model.UserRole
import dev.gitlive.firebase.firestore.CollectionReference

abstract class UserSettingsBase(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    val role: UserRole,
) : SerializableDomainModel
